import { push } from "connected-react-router";
import queryString from "query-string";

import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { toggleLoader } from "./loaderActions";
import { showAlertSuccess } from "./alertActions";
import projectService from "../services/projectService";

export function loadPESSuccess(data) {
  return {
    type: types.LOAD_PES_REPORT_SUCCESS,
    data
  };
}

export function loadDPSReportSuccess(data) {
  return {
    type: types.LOAD_DPS_REPORT_SUCCESS,
    data
  };
}

export function loadProjectSuccess(projects) {
  return {
    type: types.LOAD_PROJECT_SUCCESS,
    projects
  };
}

export function getProjectsSuccess(projects) {
  return {
    type: types.GET_PROJECTS_SUCCESS,
    projects
  };
}

export function getProjectSuccess(project) {
  return {
    type: types.GET_PROJECT_SUCCESS,
    project
  };
}

export function savingProject(status = true) {
  return {
    type: types.SAVING_PROJECT,
    savingProject: status
  };
}

export function createProjectSuccess(project) {
  return {
    type: types.CREATE_PROJECT_SUCCESS,
    project
  };
}

export function updateProjectSuccess(project) {
  return {
    type: types.UPDATE_PROJECT_SUCCESS,
    project
  };
}

export function deleteProjectSuccess(projectId) {
  return {
    type: types.DELETE_PROJECT_SUCCESS,
    projectId
  };
}

export function clearProject() {
  return { type: types.RESET_PROJECT_SUCCESS };
}

export function clearProjects() {
  return (dispatch) => dispatch(loadProjectSuccess([]));
}

export function cloneProjectSuccess(project) {
  return {
    type: types.CLONE_PROJECT_SUCCESS,
    project
  };
}

export function requestProjectId(projectId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PROJECT_ID,
      projectToDelete: projectId
    });
    dispatch(showModalSuccess("projectDeleteModal"));
  };
}

export function requestTaskId(taskId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PROJECT_TASK_ID,
      projectTaskToDelete: taskId
    });
    dispatch(showModalSuccess("taskDeleteModal"));
  };
}

export function requestNoteId(noteId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PROJECT_NOTE_ID,
      projectNoteToDelete: noteId
    });
    dispatch(showModalSuccess("noteDeleteModal"));
  };
}

export function requestAttachmentId(attachmentId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PROJECT_ATTACHMENT_ID,
      projectAttachmentToDelete: attachmentId
    });
    dispatch(showModalSuccess("attachmentDeleteModal"));
  };
}

export function requestNotificationId(notificationId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PROJECT_NOTIFICATION_ID,
      projectNotificationToDelete: notificationId
    });
    dispatch(showModalSuccess("notificationDeleteModal"));
  };
}

export function loadProjectsWithSupportResourcesSuccess(data) {
  return {
    type: types.LOAD_PROJECTS_WITH_SUPPORT_RESOURCES_SUCCESS,
    data
  };
}

export function loadProjects(body) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return projectService
      .loadProjects(body)
      .then(async (data) => {
        await dispatch(loadProjectSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error, "error")));
  };
}

export function loadDepartmentProjects(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return projectService
      .loadDepartmentProjects(payload)
      .then(async (data) => {
        await dispatch(loadDPSReportSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadProjectEmployeeSummary(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return projectService
      .loadProjectEmployeeSummary(payload)
      .then(async (data) => {
        await dispatch(loadPESSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadProjectSummary(payload) {
  return async (dispatch) =>
    projectService
      .loadProjectSummary(payload)
      .then(async (data) => {
        await dispatch(loadProjectSuccess(data));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getProjects(url) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return projectService
      .get(url)
      .then(async (data) => {
        await dispatch(getProjectsSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error, "error")));
  };
}

export function getProject(id, showPROJECTDetails = false) {
  return (dispatch) =>
    projectService
      .getProject(id)
      .then((project) => {
        dispatch(getProjectSuccess(project));
        if (showPROJECTDetails) {
          dispatch(showModalSuccess("projectDetailsModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createProject(project, redirect = true) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .createProject(project)
      .then((createdProject) => {
        dispatch(createProjectSuccess(createdProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Project created successfully", "success"));
        if (redirect) {
          dispatch(push("/app/projects"));
        }
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(
          showAlertSuccess(
            error.description || "Project ID must be unique",
            "error"
          )
        );
      });
  };
}

export function cloneProject(project, redirect = true) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .cloneProject(project)
      .then((clonedProject) => {
        dispatch(cloneProjectSuccess(clonedProject));
        dispatch(savingProject(false));
        dispatch(showAlertSuccess("Project cloned successfully", "success"));
        if (redirect) {
          dispatch(clearProject());
          dispatch(push(`/app/projects/${clonedProject.id}`));
        }
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(
          showAlertSuccess(
            error.description || "Project ID must be unique",
            "error"
          )
        );
      });
  };
}

export function updateProject(project, redirect = true) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .updateProject(project)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Project updated successfully", "success"));
        if (redirect) {
          dispatch(push("/app/projects"));
        }
        return true;
      })
      .catch(({ response }) => {
        // console.log(response);
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(response.data.errors.message, "error"));
        return false;
      });
  };
}

export function deleteProject(id) {
  return (dispatch) =>
    projectService
      .deleteProject(id)
      .then(() => {
        dispatch(deleteProjectSuccess(id));
        dispatch(showAlertSuccess("Project deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

// TASKS
export function createTask(project, task) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .createTask(project, task)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Task created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateTask(project, task) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .updateTask(project, task)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Task updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteTask(project, task) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .deleteTask(project, task)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(showAlertSuccess("Task deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

// NOTES
export function createNote(project, note) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .createNote(project, note)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Note created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateNote(project, note) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .updateNote(project, note)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("projectDetailsModal"));
        dispatch(showAlertSuccess("Note updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteNote(project, note) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .deleteNote(project, note)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(showAlertSuccess("Note deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

// ATTACHMENTS
export function uploadFile(project, files, isSOW = false) {
  return (dispatch) => {
    dispatch(savingProject());
    if (files.length === 1) {
      return projectService
        .uploadFile(project, files[0], isSOW)
        .then(() => {
          dispatch(savingProject(false));
          dispatch(
            showAlertSuccess("Attachment added successfully", "success")
          );
        })
        .catch((error) => {
          dispatch(savingProject(false));
          dispatch(showAlertSuccess(error.description, "error"));
        });
    }
    dispatch(savingProject(false));
    dispatch(showAlertSuccess("Upload 1 File at a Time", "error"));
  };
}

export function downloadFile(project, file) {
  return (dispatch) =>
    projectService.downloadFile(project, file).catch((error) => {
      dispatch(showAlertSuccess(error.description, "error"));
    });
}

export function updateAttachment(project, file) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .updateLocation(project, file)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(
          showAlertSuccess("Attachment updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteAttachment(project, file) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .deleteAttachment(project, file)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(
          showAlertSuccess("Attachment deleted successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

// NOTIFICATIONS
export function createNotification(project, notification) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .createNotification(project, notification)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("notificationDetailsModal"));
        dispatch(
          showAlertSuccess("Notification created successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateNotification(project, notification) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .updateNotification(project, notification)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(hideModalSuccess("notificationDetailsModal"));
        dispatch(
          showAlertSuccess("Notification updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteNotification(project, notification) {
  return (dispatch) => {
    dispatch(savingProject());
    return projectService
      .deleteNotification(project, notification)
      .then((updatedProject) => {
        dispatch(updateProjectSuccess(updatedProject));
        dispatch(savingProject(false));
        dispatch(
          showAlertSuccess("Notification deleted successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingProject(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateKeywordsAndRequestNatures(projectId, payload) {
  return async (dispatch) =>
    projectService
      .updateKeywordsAndRequestNatures(projectId, payload)
      .then((updated) => {
        if (updated) {
          dispatch(showAlertSuccess("Project updated successfully", "success"));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function loadProjectsWithSupportResources(query) {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return projectService
      .loadProjectsWithSupportResources(
        queryString.stringify(query, {
          arrayFormat: "bracket"
        })
      )
      .then(async (data) => {
        dispatch(loadProjectsWithSupportResourcesSuccess(data));
        dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function updateProjectSupportResources(projectId, payload) {
  return async (dispatch) =>
    projectService
      .updateProjectSupportResources(projectId, payload)
      .then((updated) => {
        if (updated) {
          dispatch(showAlertSuccess("Project updated successfully", "success"));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function loadActiveProjects(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return projectService
      .loadActiveProjects(payload)
      .then(async (data) => {
        await dispatch(loadProjectSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}
